export const redirect = (url, returnTo) => {
  if (!returnTo) {
    returnTo = window.location.href;
  }
  window.location = url + "?returnTo=" + returnTo;
};
